define([
    "dojo/_base/declare",
    "csi/heading/Ref",
    "csi/locale",
    "csi/xml"
], function(declare,Ref,locale,xml) {

    return declare(Ref, {
        getStoreOptions: function(/*Context*/ctx, /*Heading*/h) {
            return {
                customOperation: true,
                translate: function(sizeNode) {
                	var dt = locale.getEnumName(sizeNode.DimensionType);
                	if (dt != "")
                		dt = " (" + dt + ")"; // show dimension type in parens if it is not blank
                	return sizeNode.$Name + dt;
                }
            }
        }
    });
});